/** After a release the projector is still on the clock until the facilitator picks something: this offers deck slide 1 of the latest released round, so the Studio never reads "nothing to show" (U2-10). */
import type { CohortBoard, RoomScreenShow, RoomScreenView } from "@bsim/contracts";
import { useRoute } from "../api/context";
import { Icon } from "../theme/icons";

export function UpNext({ cohortId, board, room, project }: { readonly cohortId: string; readonly board: CohortBoard; readonly room: RoomScreenView | undefined; readonly project: (show: RoomScreenShow) => void }) {
  const roundNo = board.rounds.filter((r) => r.state === "released").at(-1)?.roundNo ?? null;
  const deck = useRoute("debriefGet", roundNo === null || room?.show.kind !== "clock" ? null : { cohortId }, roundNo === null ? {} : { query: { roundNo } });
  const first = deck.data?.slides.find((s) => s.slideNo === 1);
  if (first === undefined || deck.data === undefined || room?.show.kind !== "clock") return null;
  return (
    <div className="gx-fac-upnext" data-testid="room.upNext">
      <p className="gx-small gx-muted">The projector is on the clock. Slide 1 of round {deck.data.throughRoundNo} is ready: <b>{first.title}</b>.</p>
      <button type="button" className="gx-btn gx-btn--secondary" data-testid="room.upNext.project" onClick={() => project({ kind: "slide", roundNo: deck.data.throughRoundNo, slideNo: 1 })}><Icon name="room" size={14} />Project slide 1</button>
    </div>
  );
}
